import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';
import { LogService } from './log.service';
import { Dupe } from '../models/dupe.model';
import { Invitation } from '../models/invitation.model';
import { InteractivityChecker } from '@angular/cdk/a11y';
import { Invite } from '../models/invite.model';

@Injectable({ providedIn: 'root' })
export class InvitationsService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
    private logService: LogService
  ) {}

  getInvitations(userId: string, suppress: boolean) {
    let promise = new Promise<Invitation[]>((resolve, reject) => {
      return this.http
        .get<Invitation[]>(
          this.apiHost +
            '/Invitation/GetInvitations?UserId=' +
            userId +
            '&Suppress=' +
            suppress
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Invitations', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  acceptInvitation(invitation: Invite): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Invitation/AcceptInvitation', invitation)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Accept Invitation', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  declineInvitation(invitation: Invite) {
    let promise = new Promise((resolve, reject) => {
      return this.http
        .post(this.apiHost + '/Invitation/DeclineInvitation', invitation)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Accept Invitation', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  suppressInvitation(invitation: Invite) {
    let promise = new Promise((resolve, reject) => {
      return this.http
        .post(this.apiHost + '/Invitation/SuppressInvitation', invitation)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Accept Invitation', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }
}
